import React from 'react';
import BN from 'bignumber.js';
import cn from 'classnames';
import { Input } from '../../../../components/form';
import styles from '../styles/stake/stake-settings.module.scss';
import PercentageButtons from '../../percentage-buttons';
import { useGetTheme } from '../../../../hooks/useGetTheme';
import PropTypes from 'prop-types';

const InputRow = ({
  currency,
  title,
  inputValue,
  balance,
  handleAmountChange,
  minText,
  toPowerOf,
}) => {
  const colors = useGetTheme();

  return (
    <>
      <div className={styles.bodyTitle}>{title}</div>
      <div className={styles.inputRow}>
        <span className={styles.inputRowLabel} style={{ color: colors.text }}>
          {currency}
        </span>
        <div className={styles.inputRowContainer}>
          <Input
            value={inputValue}
            onChange={(e) =>
              handleAmountChange({
                amount: new BN(e.target.value || '0').times(toPowerOf).toString(10),
              })
            }
            type='number'
          />
          {minText ? <span className={styles.inputRowDesc}>Min. {minText}</span> : null}
          <div className={cn(styles.percentageContainer, styles.noWrap)}>
            <PercentageButtons balance={balance} onClick={handleAmountChange} />
          </div>
        </div>
      </div>
    </>
  );
};

InputRow.propTypes = {
  currency: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  handleAmountChange: PropTypes.func.isRequired,
  balance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  inputValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  toPowerOf: PropTypes.number.isRequired,
  minText: PropTypes.string,
};

export default InputRow;
